import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-stacked-card-next',
    template: ` <ng-content select="cmps-card-next"></ng-content>`,
    host: {
        class: 'cmps-stacked-card-next',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsStackedCardComponent {}
